import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import PageLayout from '../../components/layout/PageLayout';
import ActionDialog from '../../components/dialog/ActionDialog';

const LoginError = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) {
      return;
    }
    hasProcessed.current = true;

    const message = searchParams.get('message') || '로그인 중 오류가 발생했습니다.';
    setErrorMessage(message);
    setDialogOpen(true);
  }, [searchParams]);

  const handleDialogClose = () => {
    setDialogOpen(false);
    navigate('/login', { replace: true });
  };

  return (
    <PageLayout>
      <ActionDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleDialogClose}
        showCancel={false}
      >
        <Typography sx={{ textAlign: 'center' }}>{errorMessage}</Typography>
      </ActionDialog>
    </PageLayout>
  );
};

export default LoginError;
